import React from 'react';
import { useSelector } from 'react-redux';
import EquipmentTemplate from '../../components/equiqtemplate/EquipmentTemplate';
import WelderImg1 from '../../assest/Welder-1.jpeg';
import WelderImg2 from '../../assest/Welder-2.png';
import WelderImg3 from '../../assest/Welder-3.png';

const weldersList = [
  {
    name: "Structural Welder",
    image: WelderImg1,
    specs: "Welding for buildings, bridges, and infrastructure.",
    description: "Specialized in high-strength welding for large-scale structural frameworks.",
  },
  {
    name: "Pipe Welder",
    image: WelderImg2,
    specs: "Expertise in pipeline welding and repair.",
    description: "Skilled in handling high-pressure systems and industrial pipework.",
  },
  {
    name: "Fabrication Welder",
    image: WelderImg3,
    specs: "Custom fabrication for machinery and components.",
    description: "Experienced in blueprint interpretation and precision welding for custom builds.",
  },
];

const translations = {
  gb: {
    heading: "Welder Services",
    introText: "Professional welding services for industrial, commercial, and custom fabrication projects.",
    categoriesTitle: "Available Services",
    featuredTitle: "Top Welders",
    featuredDescription: "Certified welders skilled in a range of welding techniques for every job.",
  },
  sa: {
    heading: "خدمات اللحام",
    introText: "خدمات لحام احترافية للمشاريع الصناعية والتجارية والتصنيع المخصص.",
    categoriesTitle: "الخدمات المتاحة",
    featuredTitle: "أفضل الحدادين",
    featuredDescription: "لحامون معتمدون ماهرون في مجموعة من تقنيات اللحام لكل نوع من أنواع العمل.",
  },
};

const Welders = () => {
  const { language } = useSelector((state) => state.language);
  const t = translations[language] || translations.gb;

  return (
    <EquipmentTemplate
      content={t}
      equipmentList={weldersList}
      language={language}
    />
  );
};

export default Welders;
